<template>
  <div
    :class="$style.customer"
    :title="agency?.customerId"
    :data-cy="`agency-switcher-current-${agency?.customerId}`"
  >
    <img
      v-if="agencyURL"
      :src="agencyURL"
      :class="[$style.customerLogo, $style.imageRounded]"
      alt=""
      aria-hidden="true"
      @error="showAgencyFirstLetter"
    />
    <div v-else :class="[$style.customerLetter, $style.imageRounded]">
      {{ agency?.customerId?.[0]?.toLocaleUpperCase() || '' }}
    </div>
    <div :class="$style.customerInfo">
      <strong>{{ agency?.legalName }}</strong>
      <span data-cy="agency-switcher-customer-id">{{ agency?.customerId }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { type AgencyDetails } from '@/types-agency';
import { ref, type PropType } from 'vue';

const { agency } = defineProps({
  agency: {
    type: Object as PropType<AgencyDetails>,
    required: true,
  },
});

const agencyURL = ref(agency?.logoUrl);

const showAgencyFirstLetter = () => {
  agencyURL.value = undefined;
};
</script>

<style lang="scss" module>
@import '@smg-real-estate/domus/style-tokens-mixins.scss';
@import './styles';

.imageRounded {
  @include sidebar-image-rounded;

  & {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid $color-white;
  }
}

.customer {
  position: relative;
  display: flex;
  flex: 1;
  gap: $space-100;
  align-items: center;
  height: 100%;

  .customerLogo {
    object-fit: contain;
    background-color: $color-white;
  }

  .customerLetter {
    @include body-1-bold($color-white);

    & {
      flex-shrink: 0;
      background-color: $color-grey-90;
    }
  }

  .customerInfo {
    @include truncate-text;

    > span,
    > strong {
      @include truncate-text;

      & {
        display: block;
      }
    }

    > strong {
      @include body-3-bold;

      & {
        font-size: 1rem;
      }
    }

    > span {
      @include body-3;

      & {
        font-size: 0.75rem;
      }
    }
  }
}
</style>
